import { Module, MutationTree, GetterTree, ActionTree } from 'vuex';
import { ReducerStatus, RootState } from '../types';
import { MetaFlightState } from './types';

const initialState: MetaFlightState = {
    status: ReducerStatus.INITIAL,
    showErrors: false,
    data: {
        Flight: null,
        MetaData: null,
        Destination: null,
        RelatedHotels: [],
    },
};

const state: MetaFlightState = {
    ...initialState,
};

const getters: GetterTree<MetaFlightState, RootState> = {
    getFlight(state: MetaFlightState) {
        return state.data.Flight;
    },
    getMetaData(state: MetaFlightState) {
        return state.data.MetaData;
    },
    getDestination(state: MetaFlightState) {
        return state.data.Destination;
    },
    getRelatedHotels(state: MetaFlightState) {
        return state.data.RelatedHotels;
    },
};

const actions: ActionTree<MetaFlightState, RootState> = {
    setLoading({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.LOADING,
        });
    },

    setUpdating({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.UPDATING,
        });
    },

    setLoaded({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.LOADED,
        });
    },

    setSuccess({ state, commit }, payload) {
        commit('setState', {
            ...state,
            status: ReducerStatus.LOADED,
            data: {
                ...state.data,
                Flight: payload,
            },
        });
    },

    setMetaData({ state, commit }, payload) {
        commit('setState', {
            ...state,
            data: {
                ...state.data,
                MetaData: payload,
            },
        });
    },

    setDestination({ state, commit }, payload) {
        commit('setState', {
            ...state,
            data: {
                ...state.data,
                Destination: payload,
            },
        });
    },

    setRelatedHotels({ state, commit }, payload) {
        commit('setState', {
            ...state,
            data: {
                ...state.data,
                RelatedHotels: payload,
            },
        });
    },

    setError({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.ERROR,
            data: null,
        });
    },

    setShowErrors({ commit }, payload) {
        commit('setShowErrors', payload);
    },
};

const mutations: MutationTree<MetaFlightState> = {
    setState(state, payload: MetaFlightState) {
        state.status = payload.status;
        state.data = payload.data;
    },
    setShowErrors(state, payload: boolean) {
        state.showErrors = payload;
    },
};

export const metaFlight: Module<MetaFlightState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
